export default "__VITE_ASSET__CIfz5Afc__"